import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Region } from "../types/regions";

export type RegionsSlice = {
  regions: Region[] | Record<string, never>;
  gettingRegions: boolean;
  getRegionsSuccess: boolean;
  getRegionsError: boolean;
  getRegionsErrorMessage: string;
};

const initialState: RegionsSlice = {
  regions: {},
  gettingRegions: false,
  getRegionsSuccess: false,
  getRegionsError: false,
  getRegionsErrorMessage: ""
};

const regionsSlice = createSlice({
  name: "regions",
  initialState,
  reducers: {
    gettingRegions(state) {
      state.regions = {};
      state.gettingRegions = false;
      state.getRegionsSuccess = false;
      state.getRegionsError = false;
      state.getRegionsErrorMessage = "";
    },
    getRegionsFailed(state, action: PayloadAction<string>) {
      state.regions = {};
      state.gettingRegions = false;
      state.getRegionsSuccess = false;
      state.getRegionsError = true;
      state.getRegionsErrorMessage = action.payload;
    },
    getRegionSuccess(state, action: PayloadAction<Region[]>) {
      state.regions = action.payload;
      state.gettingRegions = false;
      state.getRegionsSuccess = true;
      state.getRegionsError = false;
      state.getRegionsErrorMessage = "";
    }
  }
});

export const { gettingRegions, getRegionsFailed, getRegionSuccess } = regionsSlice.actions;

export default regionsSlice.reducer;
